import { render } from "./limit-exception.vue?vue&type=template&id=4593d738&ts=true"
import script from "./limit-exception.ts?vue&type=script&lang=ts"
export * from "./limit-exception.ts?vue&type=script&lang=ts"

import "./limit-exception.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__